import createAxios from '@/app/core/AxiosCore';
import config from '@/app/config/app';

const axios = createAxios(config);

function listar(paginacao) {
  return axios.get(`tipoos`, {params: paginacao})
    .then(response => response.data);
}

function buscar(busca) {
  return axios.get(`tipoos/buscar?busca=${busca}`)
    .then(response => response.data);
}

function buscarPorCodigo(codigo) {
  return axios.get(`tipoos/buscarCodigo?codigo=${codigo}`)
    .then(response => response.data);
}

function abrir(id) {
  return axios.get(`/tipoos/${id}`)
    .then(response => response.data);
}

function salvar(tipoos) {
  return axios.post('/tipoos', tipoos)
    .then(response => response.data);
}

function atualizar(tipoos) {
  return axios.put(`/tipoos/${tipoos.id}`, tipoos)
    .then(response => response.data)
}

function excluir(id) {
  return axios.delete(`/tipoos/${id}`)
    .then(response => response.data);
}


export default {
  listar,
  buscar,
  buscarPorCodigo,
  abrir,
  salvar,
  atualizar,
  excluir
}
